module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "skumanagement"
  }, [_c('a-layout', {
    staticStyle: {
      "min-height": "100vh"
    },
    attrs: {
      "id": "components-layout-demo-side"
    }
  }, [_c('menuBar', {
    attrs: {
      "current": _vm.current,
      "openKeys": _vm.openKeys
    }
  }), _vm._v(" "), _c('a-layout', {
    staticStyle: {
      "overflow": "auto"
    }
  }, [_c('topBar'), _vm._v(" "), _c('a-layout-content', {
    staticStyle: {
      "margin": "16px",
      "min-width": "1192px"
    }
  }, [_c('div', {
    staticStyle: {
      "font-size": "20px",
      "line-height": "30px",
      "margin-bottom": "10px",
      "font-weight": "700",
      "padding-left": "8px"
    }
  }, [_vm._v("SKU管理")]), _vm._v(" "), _c('div', {
    staticClass: "contentcard"
  }, [_c('div', {
    staticStyle: {
      "padding-bottom": "50px"
    }
  }, [_c('div', [_c('a-button', {
    staticStyle: {
      "width": "96px",
      "margin-bottom": "15px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.newskubtn
    }
  }, [_vm._v("新增商品")]), _vm._v(" "), _c('div', [_c('a-row', {
    staticStyle: {
      "background-color": "#f3f3f5",
      "font-size": "14px",
      "height": "60px",
      "font-weight": "700"
    },
    attrs: {
      "type": "flex",
      "justify": "space-around",
      "align": "middle"
    }
  }, [_c('a-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 2
    }
  }, [_vm._v("商品名")]), _vm._v(" "), _c('a-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 2
    }
  }, [_vm._v("提成数")]), _vm._v(" "), _c('a-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 2
    }
  }, [_vm._v("货损扣除数")]), _vm._v(" "), _c('a-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 2
    }
  }, [_vm._v("业务占比")]), _vm._v(" "), _c('a-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 2
    }
  }, [_vm._v("支撑占比")]), _vm._v(" "), _c('a-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 2
    }
  }, [_vm._v("操作")])], 1)], 1), _vm._v(" "), (!_vm.skulist.length) ? _c('div', [_c('a-alert', {
    attrs: {
      "message": "查询结果为空",
      "banner": "",
      "type": "info"
    }
  })], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.skulist), function(sku) {
    return (_vm.skulist.length) ? _c('div', {
      key: sku.id,
      staticStyle: {
        "color": "#666",
        "font-size": "14px"
      }
    }, [_c('a-row', {
      staticStyle: {
        "border": "#e8e8e8 solid 1px",
        "border-top": "none",
        "padding": "10px 0"
      },
      attrs: {
        "type": "flex",
        "justify": "space-around",
        "align": "middle"
      }
    }, [_c('a-col', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "span": 2
      }
    }, [_vm._v(_vm._s(sku.sku_name))]), _vm._v(" "), _c('a-col', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "span": 2
      }
    }, [_vm._v("￥" + _vm._s(sku.sale_price / 100))]), _vm._v(" "), _c('a-col', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "span": 2
      }
    }, [_vm._v("￥" + _vm._s(sku.damage_price / 100))]), _vm._v(" "), _c('a-col', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "span": 2
      }
    }, [_vm._v(_vm._s(sku.operate_ratio / 100 + "%"))]), _vm._v(" "), _c('a-col', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "span": 2
      }
    }, [_vm._v(_vm._s(sku.technical_ratio / 100 + "%"))]), _vm._v(" "), _c('a-col', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "span": 2
      }
    }, [_c('a-button', {
      attrs: {
        "type": "link",
        "size": "small"
      },
      on: {
        "click": function($event) {
          return _vm.bianjibtn(sku)
        }
      }
    }, [_vm._v("修改")])], 1)], 1)], 1) : _vm._e()
  })], 2), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right",
      "position": "relative",
      "bottom": "-18px"
    }
  }, [_c('a-pagination', {
    attrs: {
      "showSizeChanger": "",
      "current": _vm.endpage / _vm.pageSize,
      "pageSize": _vm.pageSize,
      "total": _vm.skusum,
      "showQuickJumper": ""
    },
    on: {
      "showSizeChange": _vm.onShowSizeChange,
      "change": _vm.pageChange
    }
  })], 1)])])]), _vm._v(" "), _c('bottomBar')], 1)], 1), _vm._v(" "), _c('div', [_c('a-back-top')], 1), _vm._v(" "), _c('a-modal', {
    attrs: {
      "title": "新增商品",
      "visible": _vm.newskuvisible,
      "confirmLoading": _vm.confirmLoading
    },
    on: {
      "ok": _vm.newskuOk,
      "cancel": _vm.newskuCancel
    }
  }, [_c('div', {
    staticClass: "newsku"
  }, [_c('span', {
    staticClass: "newskutext"
  }, [_vm._v("商品名称")]), _vm._v(" "), _c('a-input', {
    staticStyle: {
      "width": "250px"
    },
    attrs: {
      "placeholder": "请输入商品名称"
    },
    model: {
      value: (_vm.newsku.sku_name),
      callback: function($$v) {
        _vm.$set(_vm.newsku, "sku_name", $$v)
      },
      expression: "newsku.sku_name"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "newsku"
  }, [_c('span', {
    staticClass: "newskutext"
  }, [_vm._v("提成数")]), _vm._v(" "), _c('a-input', {
    staticStyle: {
      "width": "250px"
    },
    attrs: {
      "placeholder": "请输入提成数"
    },
    model: {
      value: (_vm.newsku.sale_price),
      callback: function($$v) {
        _vm.$set(_vm.newsku, "sale_price", $$v)
      },
      expression: "newsku.sale_price"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "newsku"
  }, [_c('span', {
    staticClass: "newskutext"
  }, [_vm._v("货损扣除数")]), _vm._v(" "), _c('a-input', {
    staticStyle: {
      "width": "250px"
    },
    attrs: {
      "placeholder": "请输入货损扣除数"
    },
    model: {
      value: (_vm.newsku.damage_price),
      callback: function($$v) {
        _vm.$set(_vm.newsku, "damage_price", $$v)
      },
      expression: "newsku.damage_price"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "newsku"
  }, [_c('span', {
    staticClass: "newskutext"
  }, [_vm._v("业务占比")]), _vm._v(" "), _c('a-input', {
    staticStyle: {
      "width": "250px"
    },
    attrs: {
      "placeholder": "请输入业务占比"
    },
    model: {
      value: (_vm.newsku.operate_ratio),
      callback: function($$v) {
        _vm.$set(_vm.newsku, "operate_ratio", $$v)
      },
      expression: "newsku.operate_ratio"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "newsku"
  }, [_c('span', {
    staticClass: "newskutext"
  }, [_vm._v("支撑占比")]), _vm._v(" "), _c('a-input', {
    staticStyle: {
      "width": "250px"
    },
    attrs: {
      "placeholder": "请输入支撑占比"
    },
    model: {
      value: (_vm.newsku.technical_ratio),
      callback: function($$v) {
        _vm.$set(_vm.newsku, "technical_ratio", $$v)
      },
      expression: "newsku.technical_ratio"
    }
  })], 1)]), _vm._v(" "), _c('a-modal', {
    attrs: {
      "title": "商品修改",
      "visible": _vm.bianjivisible,
      "confirmLoading": _vm.confirmLoading
    },
    on: {
      "ok": _vm.bianjiOk,
      "cancel": _vm.bianjiCancel
    }
  }, [_c('div', {
    staticClass: "newsku"
  }, [_c('span', {
    staticClass: "newskutext"
  }, [_vm._v("提成数")]), _vm._v(" "), _c('a-input', {
    staticStyle: {
      "width": "250px"
    },
    attrs: {
      "placeholder": "请输入提成数"
    },
    model: {
      value: (_vm.bianjisku.sale_price),
      callback: function($$v) {
        _vm.$set(_vm.bianjisku, "sale_price", $$v)
      },
      expression: "bianjisku.sale_price"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "newsku"
  }, [_c('span', {
    staticClass: "newskutext"
  }, [_vm._v("货损扣除数")]), _vm._v(" "), _c('a-input', {
    staticStyle: {
      "width": "250px"
    },
    attrs: {
      "placeholder": "请输入货损扣除数"
    },
    model: {
      value: (_vm.bianjisku.damage_price),
      callback: function($$v) {
        _vm.$set(_vm.bianjisku, "damage_price", $$v)
      },
      expression: "bianjisku.damage_price"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "newsku"
  }, [_c('span', {
    staticClass: "newskutext"
  }, [_vm._v("业务占比")]), _vm._v(" "), _c('a-input', {
    staticStyle: {
      "width": "250px"
    },
    attrs: {
      "placeholder": "请输入业务占比"
    },
    model: {
      value: (_vm.bianjisku.operate_ratio),
      callback: function($$v) {
        _vm.$set(_vm.bianjisku, "operate_ratio", $$v)
      },
      expression: "bianjisku.operate_ratio"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "newsku"
  }, [_c('span', {
    staticClass: "newskutext"
  }, [_vm._v("支撑占比")]), _vm._v(" "), _c('a-input', {
    staticStyle: {
      "width": "250px"
    },
    attrs: {
      "placeholder": "请输入支撑占比"
    },
    model: {
      value: (_vm.bianjisku.technical_ratio),
      callback: function($$v) {
        _vm.$set(_vm.bianjisku, "technical_ratio", $$v)
      },
      expression: "bianjisku.technical_ratio"
    }
  })], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-200b879c","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/client/components/view/sale/skumanagement/index.vue
// module id = 2367
// module chunks = 1